/**
 * Identity shape the school endpoints return for teachers and students
 * (flattened from `teacher_user` / `student_user` on the backend).
 */
export interface SchoolUserIdentity {
  username?: string;
  email?: string;
  firstname?: string;
  lastname?: string;
}

/**
 * Display label for a teacher/student row.
 *
 * `username` holds the email for self-registered accounts, so it is only a
 * fallback for accounts that never got a first/last name.
 */
export function schoolUserDisplayName(
  user: SchoolUserIdentity | undefined | null,
  fallback = '-',
): string {
  if (!user) return fallback;
  const fullName = `${user.firstname || ''} ${user.lastname || ''}`.trim();
  return fullName || user.username || user.email || fallback;
}
